"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MyPagesLayoutPage = require("./MyPagesLayoutPage");
Object.keys(_MyPagesLayoutPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MyPagesLayoutPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MyPagesLayoutPage[key];
    }
  });
});
var _prepareMyPagesLayoutProps = require("./prepareMyPagesLayoutProps");
Object.keys(_prepareMyPagesLayoutProps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _prepareMyPagesLayoutProps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _prepareMyPagesLayoutProps[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
var _translations = require("./translations");
Object.keys(_translations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _translations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _translations[key];
    }
  });
});
var _MyPagesFeature = require("./MyPagesFeature");
Object.keys(_MyPagesFeature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MyPagesFeature[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MyPagesFeature[key];
    }
  });
});
